import {
  SITE_ATTRIBUTE_GUIDELINES_PLACEMENT,
  GuidelinesPlacement,
} from 'configs/siteAndTrustAttributes';
import { useSiteStringAttributes } from 'hooks/useAttribute';
import { toGuidelinesPlacement } from 'utils/siteUtils';

export const useSiteGuidelinesPlacement = (): GuidelinesPlacement => {
  const [placement] = useSiteStringAttributes(
    SITE_ATTRIBUTE_GUIDELINES_PLACEMENT,
  );
  return toGuidelinesPlacement(placement);
};
